import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { X, Minus, Plus } from "lucide-react";
import { useEffect } from "react";

export function CartDrawer() {
  const { items, open, setOpen, remove, setQty, subtotal } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  if (!open) return null;

  const checkout = () => { setOpen(false); navigate("/checkout"); };

  return (
    <div className="fixed inset-0 z-[60]" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
      <aside className="absolute right-0 top-0 h-full w-full sm:w-[420px] bg-[var(--gu-bg)] border-l border-[var(--gu-border)] flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-[var(--gu-border)]">
          <div className="font-display text-2xl">Your basket</div>
          <button onClick={() => setOpen(false)} data-testid="close-cart" aria-label="Close cart">
            <X size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {items.length === 0 && (
            <div className="text-center py-16 text-[var(--gu-muted)]">
              <div className="font-display text-2xl mb-2">Empty for now</div>
              <div className="text-sm">Add a leaf, and we'll get it home to you.</div>
            </div>
          )}
          {items.map((item) => (
            <div key={item.id} className="flex gap-4" data-testid={`cart-item-${item.slug}`}>
              <div className="w-20 h-24 bg-[var(--gu-surface-2)] overflow-hidden shrink-0">
                {item.image && <img src={item.image} alt={item.name} className="w-full h-full object-cover" />}
              </div>
              <div className="flex-1">
                <div className="font-display text-lg leading-tight">{item.name}</div>
                <div className="text-sm text-[var(--gu-muted)] mt-1">${item.price.toFixed(2)}</div>
                <div className="mt-3 flex items-center gap-3">
                  <button onClick={() => setQty(item.id, item.quantity - 1)} className="w-7 h-7 border border-[var(--gu-border)] flex items-center justify-center hover:bg-[var(--gu-surface-2)]">
                    <Minus size={12} />
                  </button>
                  <span data-testid={`qty-${item.slug}`} className="text-sm w-6 text-center">{item.quantity}</span>
                  <button onClick={() => setQty(item.id, item.quantity + 1)} className="w-7 h-7 border border-[var(--gu-border)] flex items-center justify-center hover:bg-[var(--gu-surface-2)]">
                    <Plus size={12} />
                  </button>
                  <button onClick={() => remove(item.id)} data-testid={`remove-${item.slug}`} className="ml-auto text-xs uppercase tracking-widest-2 text-[var(--gu-muted)] hover:text-[var(--gu-primary)]">
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-[var(--gu-border)] p-6 space-y-4">
            <div className="flex justify-between overline">
              <span>Subtotal</span>
              <span data-testid="cart-subtotal">${subtotal.toFixed(2)}</span>
            </div>
            <button onClick={checkout} data-testid="checkout-btn" className="w-full bg-[var(--gu-primary)] text-[var(--gu-bg)] py-4 overline hover:bg-[var(--gu-primary)]/90 transition-colors">
              Proceed to checkout
            </button>
            <p className="text-xs text-[var(--gu-muted)] text-center">Free shipping over $75 · Mock checkout</p>
          </div>
        )}
      </aside>
    </div>
  );
}
